<template>
  <button @click="login()" type="button" class="w3-button w3-text-theme">
    <font-awesome-icon :icon="['fal', 'check-circle']" />  <span> ({{statement.meta.numJybes}})</span>
  </button> 
</template>

<script>
  import JybeButtonNonauth from "./JybeButtonNonauth.ts";

  export default JybeButtonNonauth;
</script>
